'use client';

import { Box, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { createElement, useState } from 'react';

import type { AvatarProps } from '@mui/material';
import type { BoxProps } from '@mui/system';
import type { ComponentType, FC, MouseEvent, ReactElement } from 'react';

export interface AvatarMenuProps extends BoxProps {
  avatar: ReactElement<AvatarProps>;
  settings: Array<{
    id: string;
    component: ComponentType;
  }>;
}

export const AvatarMenu: FC<AvatarMenuProps> = ({
  settings,
  avatar,
  ...props
}) => {
  // const { data, status } = useSession();
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>): void => {
    setAnchorElUser( event.currentTarget );
  };

  const handleCloseUserMenu = (): void => {
    setAnchorElUser( null );
  };

  return (
    <Box sx={{ flexGrow: 0 }} {...props}>
      <Tooltip title="Open settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          {avatar}
          {/* <Avatar title={data?.user?.email} alt="Remy Sharp" src={data?.user?.image} /> */}
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean( anchorElUser )}
        onClose={handleCloseUserMenu}
      >
        {settings.map((setting) => (
          <MenuItem key={setting.id} onClick={handleCloseUserMenu}>
            {createElement( setting.component )}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
